module.exports = __webpack_public_path__ + "static/img/img-21.e80de0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-21.png
// module id = zAWI
// module chunks = 0